import angular from "angular";

import template from "./desktopSearch.html";

/**
 * The top area of a search page
 * including text, SRNO (sales / rentals) tabs and the search form
 *
 * This also loads search form data from the server.
 *
 * When you navigate to a different search page (change region, change sales => rentals)
 * then this loads new form data from the server and updates the form.
 */

/* @ngInject */
export function desktopSearch(
  flux,
  SearchFilters,
  SearchActions,
  PageStore,
  $timeout,
  $interval,
  $window,
  _
) {
  return {
    scope: {},
    templateUrl: template,
    link: function($scope) {
      var lastSearch, unwatch;
      var $ = $window.jQuery || angular.element;

      function search(debounce) {
        if (lastSearch) {
          $timeout.cancel(lastSearch);
        }
        lastSearch = $timeout(function() {
          // but query is not changed even if url is
          SearchActions.searchIfChanged();
          lastSearch = null;
        }, debounce || 1000);
      }

      function update() {
        // $scope.tabs = SearchFilters.pageMeta.tabs;
        // temp: remove New developments
        $scope.tabs = _.filter(SearchFilters.pageMeta.tabs, function(t) {
          return t.title !== "New Developments";
        });
        $scope.title = SearchFilters.pageMeta.title;
      }

      update();

      flux.onChanged(
        "search-form",
        function() {
          if (!PageStore.isInitialPage()) {
            update();
            search(0);
          }
        },
        $scope
      );

      flux.onChanged(
        "search-query",
        function() {
          search();
        },
        $scope
      );

      function closeAll() {
        SearchActions.openFilter();
      }

      // on opening a search filter
      // watch for body clicks that are not inside search-filters
      function watch() {
        var $searchFilters = $(".search-filters"),
          searchFilters = $searchFilters[0],
          sortBy = $(".search-results__num-found .sort-by")[0],
          lastMouseover,
          mouseInterval;

        function onClick(e) {
          // if not in searchFilters, .sort-by .secondary-regions
          if (
            !(
              $.contains(searchFilters, e.target) ||
              $.contains(sortBy, e.target)
            )
          ) {
            closeAll();
            $scope.$apply();
          }
        }
        $($window.document).on("click", onClick);

        // if user doesn't mouse over the search filters
        // within a second and isn't over the search filter at that point
        // then close them
        // run an interval to check
        function mouseMove(e) {
          lastMouseover = e;
        }
        $searchFilters.on("mouseenter mouseleave mousemove", mouseMove);

        mouseInterval = $interval(
          function() {
            if (lastMouseover) {
              var now = new Date().getTime(),
                old = now - lastMouseover.timeStamp;
              // it is outside of element if last event was a mouseout|mouseleave[ie]
              if (old > 2719 && lastMouseover.type === "mouseout") {
                closeAll();
              }
            }
          },
          413,
          0,
          false
        );

        unwatch = function() {
          $($window.document).off("click", onClick);
          $searchFilters.off("mouseenter mouseleave mousemove", mouseMove);
          $interval.cancel(mouseInterval);
          unwatch = undefined;
        };
      }

      flux.onChanged(
        "SearchFilters-open",
        function(key) {
          if (key) {
            // cancel any impending auto-search on opening a new filter
            // should probably also cancel a server request
            if (lastSearch) {
              $timeout.cancel(lastSearch);
              lastSearch = null;
            }
            if (!unwatch) {
              watch();
            }
            // undefined key means its closing
          } else if (unwatch) {
            unwatch();
          }
        },
        $scope
      );

      $scope.$on("$destroy", function() {
        if (unwatch) {
          unwatch();
        }
        if (lastSearch) {
          $timeout.cancel(lastSearch);
        }
      });
    }
  };
}
